// SAMSY LICENCE

// HTTP://SAMSY.NINJA

import * as THREE from 'three'

import config from '../../../config'

import './luminosityhighpass'

import UnrealBloomPass from './unrealbloom'

import renderer from '../../../renderer'

import emitter from '../../../emitter'

// why cant I import it ? 

import Triangle from '../../../globals/triangle'


let defaultTex = new THREE.Texture()

let loader = new THREE.TextureLoader()

import Ressources from '../../../globals/ressources'


export default class Quad {

    constructor() {

        this.kernels = new THREE.Scene()

        this.camera = new THREE.OrthographicCamera(- 1, 1, 1, - 1, 0, 1);

        this.width = 1

        this.height = 1

        this.initPasses()

        this.addEvents()

    }



    render(color, bloom) {

        this.unrealKernel.pass.render(bloom)

        this.compute( this.blendKernel, {source: color, toScreen: true})
        // this.compute( this.blendKernel, {source: color, toScreen: true})

    }

    compute(kernel, opts = {}) {

        if(opts.source){

            kernel.mesh.material.uniforms.tInput.value = opts.source.texture

            kernel.mesh.material.uniforms.tInput.needsUpdate = true
        }

        if(opts.toScreen == true) {

            renderer.renderLIGHT(this.kernels, this.camera, kernel.mesh, null, true)

        }


        else {

            renderer.renderLIGHT(this.kernels, this.camera, kernel.mesh, kernel.output)

        }

    }

    initPasses() {

        
        this.unrealBloomPass   = new UnrealBloomPass(new THREE.Vector2(1, 1), {

            threshold:0.68,
            strength: 1.07,
            radius: 0.11

        });

        this.unrealKernel = {

            pass        : this.unrealBloomPass,

            output      : this.unrealBloomPass.output
        }

  
        this.blendKernel = {

            geometry: Triangle,
            material: new THREE.ShaderMaterial( {
                uniforms: {
                    tInput:     { type:'t',  value: defaultTex },
                    tInput2:    { type:'t',  value: this.unrealKernel.output },
                    resolution: { type:'v2', value: new THREE.Vector2(1, 1) },
                    aspect: {type: "f", value: 1},
                    toggle: {type: "f", value: 1}

                },
                vertexShader: require('./blend/main.vert'),
                fragmentShader: require('./blend/main.frag'),
                fog: false,
                depthTest: false,
                depthWrite: false,
                side: 2
            })

        }
        this.blendKernel.mesh = new THREE.Mesh(this.blendKernel.geometry, this.blendKernel.material)

        this.kernels.add( this.blendKernel.mesh )

    }


    resize(w, h) {

        this.width = Math.floor(w * config.devicePixelRatio)

        this.height = Math.floor(h * config.devicePixelRatio)

        let i = 0

        while(i < this.kernels.children.length ){

            this.kernels.children[i].material.uniforms.resolution.value.set(this.width / config.devicePixelRatio, this.height / config.devicePixelRatio);
             this.kernels.children[i].material.uniforms.aspect.value = w / h
            i++
        }

        this.unrealKernel.pass.setSize(this.width, this.height)

    }


    fbos(w, h, format = THREE.RGBFormat, type) {

      return new THREE.WebGLRenderTarget(w, h, {

          minFilter: THREE.LinearFilter,
          magFilter: THREE.LinearFilter,
          wrapS:  THREE.ClampToEdgeWrapping,
          wrapT:  THREE.ClampToEdgeWrapping,
          format: format
        });

    }


    addEvents() {


        emitter.on('resize', this.resize.bind(this))
    }

}



// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/postprocessing/quad/index.js